import { ApiResponseInfo } from './api.type';

export interface Enquiry {
  id: number;
  digStartAt: string;
  digEndAt: string;
  CustomFields: LodgeEnquiryPayloadType;
}

export interface LodgeEnquiryPayloadType {
  activityCode: number;
  activityDescription: string;
  isPlanningJob: boolean;
  locationInRoad: string;
  locationTypes: string[];
  notes: string;
  shape: EnquiryShape;
  workingForAuthorityName: string;
  workingForAuthorityType: string;
}

export interface EnquiryItem extends LodgeEnquiryPayloadType {
  id: number;
  digStartAt: string;
  digEndAt: string;
}

export interface EnquiryShape {
  type: string;
  coordinates: number[][][];
}

export interface loadEnqueriesSuccessPayload {
  items: EnquiryItem[];
}

export interface loadEnqueriesFailurePayload {
  error: ApiResponseInfo;
}

export interface LodgeEnqiryStep1DataType {
  userReference: string;
  digStartAt: string;
  digEndAt: string;
  notes: string;
}

export interface LodgeEnqiryStep2DataType {
  isPlanningJob: boolean;
  enquiryType: string;
  locationTypes: string[];
  authorityId: string | number | null;
  locationsInRoad: string[];
  activityTypes: string[];
}

export enum ENQUIRY_ERR_MSG {
  NOT_FOUND = 'Not Found'
}
